import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { globalStyles } from './styles/globalStyles';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import LoadingScreen from './components/LoadingScreen';
import PageTransition from './components/PageTransition';
import HomePage from './pages/HomePage';
import ResearchPage from './pages/ResearchPage';
import TechnologyPage from './pages/TechnologyPage';
import TeamPage from './pages/TeamPage';
import PartnershipsPage from './pages/PartnershipsPage';
import DevelopersPage from './pages/DevelopersPage';
import NewsPage from './pages/NewsPageEnhanced';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';

function App() {
  const [loading, setLoading] = useState(true);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  return (
    <ThemeProvider>
      <style>{globalStyles}</style>
      <LoadingScreen isVisible={loading} onComplete={handleLoadingComplete} />
      {!loading && (
        <>
          <CustomCursor />
          <Router>
            <Navigation />
            <PageTransition>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/research" element={<ResearchPage />} />
                <Route path="/technology" element={<TechnologyPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/partnerships" element={<PartnershipsPage />} />
                <Route path="/developers" element={<DevelopersPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/about" element={<AboutPage />} />
              </Routes>
            </PageTransition>
            <Footer />
          </Router>
        </>
      )}
    </ThemeProvider>
  );
}

export default App;
